import loadable from "@loadable/component"
import React from "react"

const SlideBoxContainer = loadable(() => import("./SlideBox"))

const SlideBox = ({ component, grid }) => (
  <SlideBoxContainer component={component} grid={grid} />
)

export default SlideBox
